function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 255.997,
  cy: 256,
  r: 255.997,
  fill: "#41b4e6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M512 256.003c0-6.238-.235-12.419-.673-18.546L405.228 131.36 106.772 248.759l114.191 114.192 1.498 5.392 1.939-1.955.008.008-1.947 1.947L348.778 494.66C444.298 457.5 512 364.663 512 256.003z",
  fill: "#0091c8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M231.138 293.3l115.691 87.347 58.399-249.287-298.457 117.399 90.817 30.081 165.743-111.176z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d2d2d7",
  d: "M197.588 278.84l24.873 89.504 8.677-75.044 132.193-125.636z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#b9b9be",
  d: "M268.738 321.688l-46.277 46.656 8.677-75.044z"
});

function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgTelegram;